import { render, staticRenderFns } from "./virtual-class-video-stream.component.vue?vue&type=template&id=11c06556"
import script from "./virtual-class-video-stream.component.ts?vue&type=script&lang=ts&external"
export * from "./virtual-class-video-stream.component.ts?vue&type=script&lang=ts&external"
import style0 from "./virtual-class-video-stream.component.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports